import React from "react";
import { Link, useLocation } from "react-router-dom";

interface Props {
  label?: string;
  selected?: boolean;
  path: string; // we can change this to just id
  icon?: React.ReactNode;
}

const CategoryButton: React.FC<Props> = ({ label, selected, path, icon }) => {
  const location = useLocation();

  // Merge current search params with new category
  const searchParams = new URLSearchParams(location.search);
  searchParams.set("category", path); // path = cat.id in your usage

  return (
    <Link
      to={`${location.pathname}?${searchParams.toString()}`}
      className={`flex-shrink-0 flex items-center gap-2 px-4 py-2 rounded-[20px] font-medium whitespace-nowrap capitalize ${
        selected ? "bg-primaryButton text-white" : "bg-white shadow-md text-Black "
      }`}
    >
      {icon}
      {label}
    </Link>
  );
};

export default CategoryButton;
